import React, { useEffect } from 'react';
import classNames from 'classnames';

export const ViewTab = React.memo(
    ({
        label,
        className,
        index,
        onTabSelected,
        onTabReady,
        disabled,
        badge,
        isActive,
        children,
    }) => {
        useEffect(
            () => {
                onTabReady(index, () => {});
            },
            [index, onTabReady]
        );

        const handleTabClick = () => {
            if (!disabled) {
                onTabSelected(index);
            }
        };

        return (
            <div
                className={classNames('view-tab', className, {
                    active: isActive,
                    disabled,
                })}
                onClick={handleTabClick}
            >
                {label}
                {badge && <div className="notification-badge">{badge}</div>}
            </div>
        );
    }
);

export default ViewTab;
